import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { BasicUser } from 'src/app/domain/models/User';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css'],

})
export class DisclaimerComponent implements OnInit {
  visibleDisclaimerENGDialog: boolean = false
  visibleDisclaimerESPDialog: boolean = false

  profile: BasicUser | undefined

  isVisible: boolean = true

  constructor(
    private _authService: AuthGateway,
    private _profileService: ProfileGateway,
    private _messageService: MessageService,
    public translate: TranslateService,
  ){
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    if(this.profile)
    {
      let showModal = true
      let activeBeta = this.profile.activeBetaId != null ? true : false
      localStorage.setItem('_dsclm_sh', JSON.stringify(activeBeta));
      sessionStorage.setItem('_disclaimer_',  JSON.stringify(activeBeta));
      const disclaimValue = localStorage.getItem('_dsclm_sh')
      if (disclaimValue) {
        const parseValue = JSON.parse(disclaimValue);
        if (typeof parseValue !== 'boolean') showModal = true
        showModal = parseValue
      }
      if (showModal) {
        this.openDisclaimerDialog()
      }
    }

    this.loadBoolean();
  }

  openDisclaimerDialog() {
    localStorage.setItem('_dsclm_sh', JSON.stringify(true))
    switch(this.profile?.lang) {
      case 'en':
        this.visibleDisclaimerENGDialog = true
        break

      case 'es':
        this.visibleDisclaimerESPDialog = true
        break

      default:
         this.visibleDisclaimerENGDialog = true
    }
  }

  closeDisclaimerDialog() {
  if(this.profile?.activeBetaId)
    {
      this._profileService.confirmBetaVersion(this.profile.activeBetaId).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.System.ConfirmBetaSuccess') })
            this.isVisible = false;
            sessionStorage.setItem('_disclaimer_', JSON.stringify(false));
            localStorage.setItem('_dsclm_sh', JSON.stringify(false));
            this.visibleDisclaimerENGDialog = false
            this.visibleDisclaimerESPDialog = false
            this._profileService.getBasicUser().subscribe({
              next: (v) => {
                localStorage.setItem('_auth_user', JSON.stringify(v))
              },
              error: (e) => {
                console.log(e)
              }
            })
        },
        error: (e) => {
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.System.ConfirmBetaFailed') })
        }
      })
    }
  }

  closeDisclaimer(): void {
    if(this.profile?.activeBetaId)
    {
      this._profileService.confirmBetaVersion(this.profile.activeBetaId).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.System.ConfirmBetaSuccess') })
          this.isVisible = false;
          this._profileService.getBasicUser().subscribe({
            next: (v) => {
              localStorage.setItem('_auth_user', JSON.stringify(v))
            },
            error: (e) => {
              console.log(e)
            }
          })
          sessionStorage.setItem('_disclaimer_', JSON.stringify(false));
          localStorage.setItem('_dsclm_sh', JSON.stringify(false));
        },
        error: (e) => {
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Variety.ManyRetrieveError') })
        }
      })
    }

    this.isVisible = false;
    sessionStorage.setItem('_disclaimer_', JSON.stringify(this.isVisible));
  }

  loadBoolean() {
    const storedDisclaimer = sessionStorage.getItem('_disclaimer_');
    if (storedDisclaimer !== null) {
      this.isVisible = JSON.parse(storedDisclaimer);
    }
  }

}
